const THRESHOLD_BYTES = 18 * 1024;

export function calcBarPercent(bytes: number): number {
  if (bytes <= THRESHOLD_BYTES) return (bytes / THRESHOLD_BYTES) * 90;
  const excess = bytes - THRESHOLD_BYTES;
  const ratio = (excess / 2048) ** 0.32;
  return 90 + 10 * (1 - 1 / (1 + ratio));
}

export function formatProgressMetrics(
  tokensReceived?: number,
  contentLength?: number,
  bytesReceived?: number,
): string {
  if (!tokensReceived && !contentLength && !bytesReceived) return "-";
  const tokens = tokensReceived ?? 0;
  const bytes = contentLength ?? bytesReceived ?? 0;
  return `${tokens.toLocaleString()} tok / ${(bytes / 1024).toFixed(1)} KB`;
}
